import {
  fireEvent as fireEventInGTM,
  pageView as pageViewInGTM,
} from './gtmHelper';

import { post } from '../api/api';
import { Routes } from '../types/routeTypes';
import { getCurrentAuthToken } from './authHelpers';
import { getLocalAppSession } from './storageHelpers';
import posthog from 'posthog-js';

type payloadType = {
  [key: string]: any;
};

/**
 * Push event
 * @param event Event identifier
 * @param payload Optional custom payload
 */
export const fireEvent = (event: string, payload: payloadType = {}) => {
  if (!import.meta.env.DEV) {
    const session = getLocalAppSession();
    const newPayload = {
      ...payload,
      userId: session.userId,
      firstName: session.firstName,
      lastName: session.lastName,
      customerName: session.customerName,
      activeCustomer: session.activeCustomer,
      activeVacancy: session.activeVacancy,
      isAdmin: session.isAdmin,
    };
    fireEventInGTM(event, newPayload);

    postToAPI(event, newPayload);

    posthog.capture(event, payload);
  } else {
    console.log('🔥', event, payload);
  }
};

/**
 * Push page view event
 * @param page Page
 * @param payload Optional custom payload
 */
export const pageView = (pageFrom: string, pageTo: string, payload = {}) => {
  const session = getLocalAppSession();
  payload = {
    ...payload,
    'from-route': pageFrom,
    userId: session.userId,
    firstName: session.firstName,
    lastName: session.lastName,
    customerName: session.customerName,
    isAdmin: session.isAdmin,
  };

  if (!import.meta.env.DEV) {
    pageViewInGTM(pageTo, payload);

    // While a two-factor code is pending the server refuses everything but
    // the code check itself (468), so a ping from that screen can only fail.
    if (pageTo !== Routes.TWO_FACTOR)
      postToAPI('pageview', { route: pageTo, ...payload });
  } else {
    console.log('🔎', pageTo, payload);
  }
};

const postToAPI = (type: string, payload: object) => {
  // Check if user is logged in
  const token = getCurrentAuthToken();
  if (!token) return;

  post('/v4/events', {
    type: type,
    payload: payload,
    origin: 'APP',
  }).catch(() => {
    // Analytics only: a refused ping (expired session, pending two-factor)
    // must not surface as an unhandled rejection. The response interceptor
    // in api/api.ts already logs it and handles the redirect.
  });
};
